module.exports = __webpack_public_path__ + "static/waves-left-399a1f9bd47f4594dfe42f73c826a2d7.png";